import type { LessonConfig } from "./lessonTypes";

export type LessonFactory = () => LessonConfig;

/** A course is a fully separate progression with its own unit numbering. */
export type CourseId = "classic" | "apcsp";

export interface CourseInfo {
  id: CourseId;
  name: string;
  description: string;
}

export const COURSES: readonly CourseInfo[] = [
  {
    id: "classic",
    name: "Classic Karel",
    description:
      "The original Stanford Karel progression: commands, programs, functions, and more.",
  },
  {
    id: "apcsp",
    name: "AP CSP",
    description:
      "An AP Computer Science Principles course built around variables, procedures, lists, and input/output.",
  },
];

/** Preview snippet shown on the home screen, one per editor language. */
export interface UnitSnippets {
  js?: string;
  python?: string;
}

export interface Unit {
  name: string;
  lessons: LessonFactory[];
  snippets?: UnitSnippets;
}

const registry: Record<CourseId, Unit[]> = {
  classic: [],
  apcsp: [],
};

export function registerUnit(
  name: string,
  lessons: LessonFactory[],
  snippets?: UnitSnippets,
  course: CourseId = "classic",
): void {
  registry[course].push({ name, lessons, snippets });
}

export function getUnits(course: CourseId = "classic"): readonly Unit[] {
  return registry[course];
}

export function getCourse(id: CourseId): CourseInfo {
  return COURSES.find((course) => course.id === id) ?? COURSES[0];
}
